import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for placing an order
export const placeOrder = createAsyncThunk(
  'checkout/placeOrder',
  async (formData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/orders`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const checkoutSlice = createSlice({
  name: 'checkout',
  initialState: {
    selectedAddress: '',
    orderType: 'COD',
    couponCode: 'ABC123',
    checkoutData: null,
    prescription: null,
    uploadedPrescription: null,
    loading: false,
    error: null,
    orderSuccess: false,
    orderDetails: null,
  },
  reducers: {
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },
    setCouponCode: (state, action) => {
      state.couponCode = action.payload;
    },
    setCheckoutData: (state, action) => {
      state.checkoutData = action.payload;
    },
    setUploadedPrescription: (state, action) => {
      state.uploadedPrescription = action.payload;
    },
    clearUploadedPrescription: (state) => {
      state.uploadedPrescription = null;
    },
    resetCheckoutState: (state) => {
      state.selectedAddress = '';
      state.orderType = 'COD';
      state.couponCode = 'ABC123';
      state.checkoutData = null;
      state.prescription = null;
      state.uploadedPrescription = null;
      state.loading = false;
      state.error = null;
      state.orderSuccess = false;
      state.orderDetails = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placeOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(placeOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.orderSuccess = true;
        state.orderDetails = action.payload;
      })
      .addCase(placeOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedAddress,
  setOrderType,
  setCouponCode,
  setCheckoutData,
  setUploadedPrescription,
  clearUploadedPrescription,
  resetCheckoutState,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
